import { render, staticRenderFns } from "./IncomeHistory.vue?vue&type=template&id=70fe7660&scoped=true&"
import script from "./IncomeHistory.vue?vue&type=script&lang=js&"
export * from "./IncomeHistory.vue?vue&type=script&lang=js&"
import style0 from "./IncomeHistory.vue?vue&type=style&index=0&id=70fe7660&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fe7660",
  null
  
)

export default component.exports